<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100      
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="bannerStatus" @change="getBannerList(true)" :disabled="loading" size="sm")
            option(value=0) {{ $t('ui.all') }}
            option(value=1) {{ $t('ui.active') }}
            option(value=-1) {{ $t('ui.inactive') }}
      .form-group.col-12.col-lg-6.col-xl-4
        b-input-group(size="sm")
          b-input-group-text(slot="prepend" :title="$t('ui.slot_view')")
            span {{ $t('ui.slot_view') }}
          b-input-group-text(slot="append")
            label.custom-switch
              input.custom-switch-input(
                type='checkbox'
                name='custom-switch-checkbox'
                v-model="viewType"
                @change="getBannerList(true)"
                :true-value="1"
                :false-value="2")
              span.custom-switch-indicator
      .form-group.col-12.mb-1(v-if="isEditAccess")
        b-button(v-b-modal.addSlideBanner type="button" variant="info" size="sm")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_slide_banner") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")              
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="9%" )
                  span(:title="$t('ui.en_img_desktop')") {{ $t("ui.en_img_desktop") }}
                th(width="9%" )
                  span(:title="$t('ui.cn_img_desktop')") {{ $t("ui.cn_img_desktop") }}
                th(width="9%")
                  span(:title="$t('ui.local_img_desktop')") {{ $t("ui.local_img_desktop") }}
                th(width="9%")
                  span(:title="$t('ui.en_img_mobile')") {{ $t("ui.en_img_mobile") }}
                th(width="9%")
                  span(:title="$t('ui.cn_img_mobile')") {{ $t("ui.cn_img_mobile") }}
                th(width="9%")
                  span(:title="$t('ui.local_img_mobile')") {{ $t("ui.local_img_mobile") }}
                th(width="5%")
                  span(:title="$t('ui.target')") {{ $t("ui.target") }}
                th(width="5%")
                  span(:title="$t('ui.login_required')") {{ $t("ui.login_required") }}
                th.text-right(width="5%")
                  span(:title="$t('ui.from')") {{ $t("ui.from") }}
                th.text-right(width="5%")
                  span(:title="$t('ui.to')") {{ $t("ui.to") }}
                th.text-center(width="5%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="10%" v-if="isEditAccess")
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
            tbody.clusterize-content
              tr(v-if="bannerList.length == 0")
                td(:colspan="isEditAccess ? '14' : '13'").text-center
                  span {{ $t('message.no_data_available') }}
              tr(
                v-for="(item, index) in bannerList"
                draggable="true"
                @dragstart="handleDragStart($event, index)"
                @dragover.prevent
                @dragenter="handleDragEnter($event, index)"
                @dragleave="handleDragLeave"
                @drop="handleDrop($event, index)"
                @dragend="handleDragEnd"
                :id="item.id"
              )
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td.grabbable
                  span(v-if="item.en_image_url_desktop")
                    b-img.fiximg(:src="getImgPath(item.en_image_url_desktop)" @error="handleImageError")
                td
                  span(v-if="item.cn_image_url_desktop")
                    b-img.fiximg(:src="getImgPath(item.cn_image_url_desktop)" @error="handleImageError")
                td
                  span(v-if="item.local_image_url_desktop")
                    b-img.fiximg(:src="getImgPath(item.local_image_url_desktop)" @error="handleImageError")
                td
                  span(v-if="item.en_image_url_mobile")
                    b-img.fiximg(:src="getImgPath(item.en_image_url_mobile)" @error="handleImageError")
                td
                  span(v-if="item.cn_image_url_mobile")
                    b-img.fiximg(:src="getImgPath(item.cn_image_url_mobile)" @error="handleImageError")
                td
                  span(v-if="item.local_image_url_mobile")
                    b-img.fiximg(:src="getImgPath(item.local_image_url_mobile)" @error="handleImageError")
                td
                  span(:title="item.target_window") {{ getTargetWindow(item.target_window) }}
                td.text-center
                  span
                    i(:class="{'fas fa-check text-info': item.login_required, 'fas fa-times text-warning': !item.login_required  }")
                td.text-right
                  span(:title="$moment(item.active_from).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.active_from") {{ $moment(item.active_from).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  span(:title="$moment(item.active_to).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.active_to") {{ $moment(item.active_to).format('YYYY-MM-DD, HH:mm:ss') }}
                td
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="changedBannerStatus(item, $event)" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.text-center(v-if="isEditAccess")
                  span
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                  span.ml-1
                    a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="onDelete(item)" :title="$t('ui.delete')")
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}


  addslidebanner(@clicked="addSlideBanner" @failed="handleFailed" :viewType="viewType")
  editslidebanner(ref="editslidebanner" :item="editSelectedBanner" @clicked="afterEditBanner" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addslidebanner from "@/components/cms/addSlideBanner.vue";
import editslidebanner from "@/components/cms/editSlideBanner.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addslidebanner,
    editslidebanner,
  },
  props: {
    currTab: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    bannerList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "item_order",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedBanner: null,
    bannerStatus: 1,
    imagePath: config.viewImageUrl,
    viewType: 1,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeCms;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_cms");
    }
  },
  mounted: function() {
    // this.getBannerList(true);
  },
  methods: {
    getImgPath: function(img) {
      // const url = new URL(img); 
      const url = URL.parse(img);
      if (url != null && url.protocol === "https:") {
        return img
      } else {
        return this.imagePath + img
      }
    },
    refresh() {
      this.getBannerList(true);
    },
    handleImageError(event) {
      // event.target.src = 'https://via.placeholder.com/150?text=No+Image'; // Set fallback image
      event.target.src = 'https://placehold.co/150?text=No+Image'; // Set fallback image
    },
    handleDragStart(e, index) {
      // console.log("handleDragStart", e.target.id)
      this.dragSrcIndex = index;
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', index);
      e.target.classList.add('dragging');
    },
    handleDragEnter(e, index) {
      e.target.parentElement.classList.add('over');
      // e.target.classList.add('over');
    },
    handleDragLeave(e) {
      e.target.parentElement.classList.remove('over');
      // e.target.classList.remove('over');
    },
    handleDrop(e, index) {
      e.stopPropagation();
      e.target.parentElement.classList.remove('over');
      // e.target.classList.remove('over');

      const dragSrcIndex = this.dragSrcIndex;
      // console.log("handleDrop", dragSrcIndex, index)
      if (dragSrcIndex !== index) {
        const draggedItem = this.bannerList[dragSrcIndex];
        const targetItem = this.bannerList[index];
        // console.log("draggedItem", draggedItem.vip_id, targetItem.item_order)
        if(this.isEditAccess)
          this.confirmBannerMove(draggedItem.id, draggedItem.en_title, targetItem.item_order);
      }

      e.target.classList.remove('dragging');
    },
    handleDragEnd(e) {
      e.target.classList.remove('dragging');
    },
    confirmBannerMove: function(bannerID, enTitle, itemOrder) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.move_banner_confirm", { name: bannerID, position: itemOrder }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.bannerMove(bannerID, itemOrder);
          } else {
            this.getBannerList();
          }
        });
    },
    bannerMove: function(bannerID, itemOrder) {
      let url = config.cmsSlideBannerMoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        banner_id: bannerID,
        item_order: itemOrder
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getBannerList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.failed"), this.$t("message.move_announcement_banner"), "error");
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getBannerList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    afterEditBanner: function(item) {
      this.getBannerList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_slide_banner"), this.$t("message.success"), "success");
    },
    // afterMoveBanner: function(item) {
    //   this.getBannerList();
    //   this.$helpers.showDialog(this.$t("ui.combine.move_slide_banner"), this.$t("message.success"), "success");
    // },
    onEdit(e) {
      this.editSelectedBanner = e;
      this.$refs.editslidebanner.$refs.editSlideBanner.show();
    },
    // onMove(e) {
    //   this.editSelectedBanner = e;
    //   this.$refs.moveslidebanner.$refs.moveSlideBanner.show();
    // },
    onDelete: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_banner_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBannerDelete(item);
          }
        });
    },
    confirmBannerDelete: function(item, isUp) {
      let url = config.cmsSlideBannerDeleteUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        banner_id: item.id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getBannerList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getBannerList: function(isSearch) {
      let url = config.cmsSlideBannerListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
        view_type: this.viewType
      };

      if (this.bannerStatus == 1) {
        json.banner_status = true;
      } else if (this.bannerStatus == -1) {
        json.banner_status = false;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.bannerList = response.data.dt;
                this.totalRow = this.bannerList.length > 0 ? this.bannerList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedBannerStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_banner_status_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBannerStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmBannerStatus: function(item, status) {
      let url = config.cmsSlideBannerStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        banner_id: item.id,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getBannerList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getBannerList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    // onUpDown: function(item, isUp) {
    //   this.$helpers
    //     .alert({
    //       title: this.$t("ui.status"),
    //       text: this.$t("message.move_banner_" + (isUp == true ? 'up' : 'down') + "_confirm", { name: item.id }),
    //       type: "question",
    //       showCancelButton: true
    //     })
    //     .then(result => {
    //       if (result.value) {
    //         this.confirmBannerUpDown(item, isUp);
    //       }
    //     });
    // },
    // confirmBannerUpDown: function(item, isUp) {
    //   let url = config.cmsSlideBannerUpDownUrl();

    //   var json = {
    //     action_by: this.$store.getters.loginId,
    //     auth_token: this.$store.getters.sessionToken,
    //     operator_id: this.operatorID,
    //     banner_id: item.id,
    //     direction: isUp
    //   };

    //   this.feedback.success = true;
    //   this.loading = true;
    //   this.$http.post(url, json).then(
    //     function(response) {
    //       this.loading = false;
    //       // Success
    //       try {
    //         if (response) {
    //           if (typeof response.data.status == "string") {
    //             this.feedback.success = response.data.status == "1";
    //           } else {
    //             this.feedback.success = response.data.status == 1;
    //           }
    //           this.feedback.status = response.data.statusdesc;
    //           if (this.feedback.success == true) {
    //             // item.status = status;
    //             this.getBannerList();
    //             this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
    //           } else {
    //             if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //           }
    //         }
    //       } catch (error) {
    //         this.feedback.success = false;
    //         this.feedback.status = errorTags.request.failed;
    //         this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //       }
    //     },
    //     function(response) {
    //       this.loading = false;
    //       // Error
    //       this.feedback.success = false;
    //       this.feedback.status = errorTags.request.failed;
    //       this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //     }
    //   );
    // },
    addSlideBanner: function() {
      this.getBannerList(true);
      this.$helpers.showDialog(this.$t("ui.combine.add_slide_banner"), this.$t("message.success"), "success");
    },
    getTargetWindow: function(type) {
      if (type == "_blank")
        return this.$t("ui.new_window_tab")
      else if (type == "_self")
        return this.$t("ui.current_page")

      return "";
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'slidebanner') return
      this.$store.dispatch("layout/setPageSizeCms", pageSize);
      this.currentPage = 1;
      this.getBannerList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getBannerList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.fiximg {
  height:40px; 
  width:100%;
}

hr {
  margin-top:0em !important;
  margin-bottom:0em !important;
  width: 50% !important;
}

.blink {
  -webkit-animation: blinking 1.5s ease infinite; /* Safari 4+ */
  -moz-animation: blinking 1.5s ease infinite; /* Fx 5+ */
  -o-animation: blinking 1.5s ease infinite; /* Opera 12+ */
  animation: blinking 1.5s ease infinite; /* IE 10+, Fx 29+ */
}

.red-bg {
  background-color: lightcoral !important
}

td {
  vertical-align: middle !important;
}
</style>